<!--
 * @Description: 文件内容描述
 * @Author: 编辑人
 * @Date: 2021-11-03 10:20:17
-->
<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" unique-opened :text-color="variables.menuText" :background-color="variables.menuBg" active-text-color="#1890FF" :collapse-transition="true" mode="vertical">
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem },
  data() {
    return {
      menu: []
    };
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    // activeMenu() {
    //   const route = this.$route;
    //   console.log("route", route);
    //   const { meta, path } = route;
    //   // if set path, the sidebar will highlight the path you set
    //   if (meta.activeMenu) {
    //     return meta.activeMenu;
    //   }
    //   return path;
    // },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    created() {
      return this.$router.options.routes.concat(global.antRouter);
    },
    routes() {
      return this.$router.options.routes.concat(global.antRouter);
    }
  },
  mounted() { }
};
</script>
